import React, { useState, useEffect } from "react";
import "../../css/ScrollingEffect.css";

const ScrollingEffect = () => {
  const [isVisible, setIsVisible] = useState(false); // State to control visibility

  useEffect(() => {
    // Set visibility to true after component mounts to trigger fade-in
    const timer = setTimeout(() => setIsVisible(true), 100); // Delay for smooth transition
    return () => clearTimeout(timer); // Cleanup timeout on unmount
  }, []);

  const images = [
    {
      src: "../Images/landingpageimage/image1.jpg",
      link: "https://example.com/image1",
      description: "Title for Image 1",
    },
    {
      src: "../Images/landingpageimage/image2.jpeg",
      link: "https://example.com/image2",
      description: "Title for Image 2",
    },
    {
      src: "../Images/landingpageimage/image3.jpg",
      link: "https://example.com/image3",
      description: "Title for Image 3",
    },
    {
      src: "../Images/landingpageimage/image4.jpg",
      link: "https://example.com/image4",
      description: "Title for Image 4",
    },
    {
      src: "../Images/landingpageimage/image5.jpg",
      link: "https://example.com/image5",
      description: "Title for Image 5",
    },
    {
      src: "../Images/landingpageimage/image6.jpg",
      link: "https://example.com/image6",
      description: "Title for Image 6",
    },
    {
      src: "../Images/landingpageimage/image7.jpg",
      link: "https://example.com/image7",
      description: "Title for Image 7",
    },
    {
      src: "../Images/landingpageimage/image8.jpg",
      link: "https://example.com/image8",
      description: "Title for Image 8",
    },
    {
      src: "../Images/landingpageimage/image9.jpg",
      link: "https://example.com/image9",
      description: "Title for Image 9",
    },
    {
      src: "../Images/landingpageimage/image10.jpg",
      link: "https://example.com/image10",
      description: "Title for Image 10",
    },
    {
      src: "../Images/landingpageimage/image11.jpg",
      link: "https://example.com/image11",
      description: "Title for Image 11",
    },
    {
      src: "../Images/landingpageimage/image12.jpg",
      link: "https://example.com/image12",
      description: "Title for Image 12",
    },
    {
      src: "../Images/landingpageimage/image13.jpg",
      link: "https://example.com/image13",
      description: "Title for Image 13",
    },
  ];

  // Function to generate random margin for each image
  const getRandomMargin = () =>
    `${Math.floor(Math.random() * 200) + 15}px auto`;

  // Function to generate random width for each image
  const getRandomWidth = () =>
    `${(Math.random() * (70 - 55) + 55).toFixed(2)}%`;

  // Duplicate the image array for infinite looping
  const infiniteImages = [...images, ...images, ...images];

  return (
    <div className={`scrolling-container ${isVisible ? "visible" : ""}`}>
      {/* Left Column */}
      <div className="image-column left">
  <div className="slideshow-track">
    {infiniteImages.map((image, index) => (
      <div key={`left-${index}`} style={{ margin: getRandomMargin() }}>
        <img
          src={image.src}
          alt={`Slide ${index + 1}`}
          style={{
            width: getRandomWidth(),
          }}
        />
        <div className="image-description"
             style={{
              opacity:"0"
            }}
        >
          <a href={image.link} target="_blank" rel="noopener noreferrer">
            {image.description}
          </a>
        </div>
      </div>
    ))}
  </div>
</div>

      {/* Right Column */}
     <div className="image-column right">
  <div className="slideshow-track">
    {infiniteImages.map((image, index) => (
      <div key={`right-${index}`} style={{ margin: getRandomMargin() }}>
        <img
          src={image.src}
          alt={`Slide ${index + 1}`}
          style={{
            width: getRandomWidth(),
          }}
        />
        <div className="image-description2"
        style={{
          opacity:"0"
        }}
        >
          <a href={image.link} target="_blank" rel="noopener noreferrer">
            {image.description}
          </a>
        </div>
      </div>
    ))}
  </div>
</div>


    </div>
  );
};

export default ScrollingEffect;
